(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cafehaus-flemming"] && !Shopify.designMode) return;
  try {
    
  function initCafehausSlideshows(root) {
    root.querySelectorAll('[data-cafe-slideshow]:not([data-cafe-ready])').forEach((slideshow) => {
      slideshow.setAttribute('data-cafe-ready', 'true');

      const slides = Array.from(slideshow.querySelectorAll('[data-cafe-slide]'));
      const dots = Array.from(slideshow.querySelectorAll('[data-cafe-dot]'));
      const previous = slideshow.querySelector('[data-cafe-prev]');
      const next = slideshow.querySelector('[data-cafe-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let currentIndex = 0;
      let autoAdvance;

      if (slides.length < 2) return;

      function showSlide(index) {
        currentIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === currentIndex);
        });
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === currentIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function stopAutoAdvance() {
        window.clearInterval(autoAdvance);
      }

      function startAutoAdvance() {
        stopAutoAdvance();
        if (!reducedMotion) {
          autoAdvance = window.setInterval(() => showSlide(currentIndex + 1), 5000);
        }
      }

      previous.addEventListener('click', () => {
        showSlide(currentIndex - 1);
        startAutoAdvance();
      });
      next.addEventListener('click', () => {
        showSlide(currentIndex + 1);
        startAutoAdvance();
      });
      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          showSlide(dotIndex);
          startAutoAdvance();
        });
      });
      slideshow.addEventListener('pointerenter', stopAutoAdvance);
      slideshow.addEventListener('pointerleave', startAutoAdvance);
      slideshow.addEventListener('focusin', stopAutoAdvance);
      slideshow.addEventListener('focusout', (event) => {
        if (!slideshow.contains(event.relatedTarget)) startAutoAdvance();
      });
      startAutoAdvance();
    });
  }

  initCafehausSlideshows(document);
  document.addEventListener('shopify:section:load', (event) => initCafehausSlideshows(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stollen-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cafe-slideshow]').forEach((slideshow) => {
    const slides = Array.from(slideshow.querySelectorAll('[data-cafe-slide]'));
    const dots = Array.from(slideshow.querySelectorAll('[data-cafe-dot]'));
    const previous = slideshow.querySelector('[data-cafe-prev]');
    const next = slideshow.querySelector('[data-cafe-next]');
    let currentIndex = 0;
    let autoAdvance;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function showSlide(index) {
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === currentIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function stopAutoAdvance() {
      window.clearInterval(autoAdvance);
    }

    function startAutoAdvance() {
      stopAutoAdvance();
      if (!reducedMotion) {
        autoAdvance = window.setInterval(() => showSlide(currentIndex + 1), 5000);
      }
    }

    previous?.addEventListener('click', () => {
      showSlide(currentIndex - 1);
      startAutoAdvance();
    });
    next?.addEventListener('click', () => {
      showSlide(currentIndex + 1);
      startAutoAdvance();
    });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        showSlide(dotIndex);
        startAutoAdvance();
      });
    });
    slideshow.addEventListener('pointerenter', stopAutoAdvance);
    slideshow.addEventListener('pointerleave', startAutoAdvance);
    slideshow.addEventListener('focusin', stopAutoAdvance);
    slideshow.addEventListener('focusout', (event) => {
      if (!slideshow.contains(event.relatedTarget)) startAutoAdvance();
    });
    startAutoAdvance();
  });

  } catch(e) { console.error(e); }
})();
})();
